import { drawerAnatomy as parts } from '@chakra-ui/anatomy'
import { Drawer as ChakraDrawer } from '@chakra-ui/react'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

import { DrawerProps } from './Drawer.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const menuListStyleVariant = definePartsStyle({
  dialog: {
    width: '12.5rem !important',
  },
})

const fullBottomStyleVariant = definePartsStyle({
  dialog: {
    height: 'calc(100% - 2rem) !important',
    borderTopRadius: '1rem',
    padding: '0',
    position: 'absolute',
    top: '2rem',
  },
  closeButton: {
    margin: '0',
    padding: '0',
    top: 'auto',
    right: 'auto',
    position: 'relative',
  },
  header: {
    borderBottom: '0.125rem solid',
    borderBottomColor: 'gray.200',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderTopRadius: '1rem',
    fontWeight: 'normal',
    fontSize: 'normal',
  },
  body: {
    padding: '1rem',
  },
})

const RightStyleVariant = definePartsStyle({
  dialog: {
    borderLeftRadius: '1rem',
    padding: '0',
    position: 'absolute',
  },
  closeButton: {
    margin: '0',
    padding: '0',
    top: 'auto',
    right: 'auto',
    position: 'relative',
  },
  header: {
    borderBottom: '0.125rem solid',
    borderBottomColor: 'gray.200',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderTopRadius: '1rem',
    fontWeight: 'normal',
    fontSize: 'normal',
  },
  body: {
    padding: '1rem',
  },
})

export const DrawerStyle = defineMultiStyleConfig({
  variants: {
    menuList: menuListStyleVariant,
    fullBottom: fullBottomStyleVariant,
    rightSide: RightStyleVariant,
  },
})

export default function Drawer(props: DrawerProps) {
  return <ChakraDrawer {...props} />
}
